import React, { useEffect } from 'react';

import { addNextButton } from './addNextButton';
import { removeNextButton } from './removeNextButton';
import { useMediaPlayer } from '../MediaPlayerProvider';

interface Props {
  title?: string;
  onClick: () => void;
}

export const NextButton: React.FC<Props> = ({ title = '', onClick }) => {
  const { player } = useMediaPlayer();

  useEffect(
    () => () => {
      if (player !== null) {
        removeNextButton(player);
      }
    },
    [player],
  );

  useEffect(() => {
    if (player !== null) {
      const buttonEl = addNextButton(player);

      if (buttonEl !== null) {
        buttonEl.setAttribute('aria-label', title);
        buttonEl.setAttribute('title', title);
        buttonEl.addEventListener('click', onClick);

        return () => {
          buttonEl.removeEventListener('click', onClick);
        };
      }
    }
    return;
  }, [onClick, player, title]);

  return null;
};
